import { createSlice } from "@reduxjs/toolkit";
const broadcastChannel = new BroadcastChannel("user-data-channel");

const admin = JSON.parse(localStorage.getItem("admin"));
const initialState = admin
  ? { isLoggedIn: true, admin }
  : { isLoggedIn: false, admin: null };

// const initialState = {
//     adminLoginData: {},
//     // token: ''

// }

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    getAdminData: (state, action) => {
      state.isLoggedIn = true;
      // The login response is flat (adminId, name, role, token, loginTime), not wrapped in
      // an "admin" key - reading .admin here left the role undefined, so AppRoutes fell back
      // to the student routes and redirected a logged-in admin to /student/login.
      state.admin = action.payload;
      // localStorage.setItem('admin', JSON.stringify(action.payload.admin));
      localStorage.setItem("admin", JSON.stringify(action.payload));
      broadcastChannel.postMessage({
        type: "GET_ADMIN",
        payload: action.payload,
      });
    },

    updateAdminData: (state, action) => {
      state.admin = action.payload;
      localStorage.setItem("admin", JSON.stringify(action.payload));
      broadcastChannel.postMessage({
        type: "UPDATE_ADMIN",
        payload: action.payload,
      });
    },

    adminLogout: (state, action) => {
      state.isLoggedIn = false;
      state.admin = null;
      localStorage.removeItem("admin");
      localStorage.removeItem("user");
      localStorage.removeItem("clickedUser");
      broadcastChannel.postMessage({ type: "LOGOUT_ADMIN" });

      // localStorage.clear();
    },
  },
});

// Delay the initial login check to allow cross-tab communication
function checkAdminDataWithDelay() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const adminData = localStorage.getItem("admin");
      resolve(adminData ? JSON.parse(adminData) : null);
    }, 100); // Adjust delay as needed for your setup
  });
}
// Listen for broadcasted messages
broadcastChannel.onmessage = async (event) => {
  // debugger
  if (event.data.type === "GET_ADMIN") {
    window.location.reload();
  }
  if (event.data.type === "UPDATE_ADMIN") {
    window.location.reload();
  }
  if (event.data.type === "UPDATE_CLICKED_ADMIN") {
    window.location.reload();
  } else if (event.data.type === "LOGOUT_ADMIN") {
    localStorage.removeItem("admin");

    window.location.href = "/admin/login";
  } else if (event.data.type === "REQUEST_ADMIN_DATA") {
    const adminData = localStorage.getItem("admin");
    if (adminData) {
      broadcastChannel.postMessage({
        type: "UPDATE_ADMIN",
        payload: JSON.parse(adminData),
      });
    }
  }
};

// When a new tab is opened and finds no session data, it requests the data
if (!localStorage.getItem("admin")) {
  broadcastChannel.postMessage({ type: "REQUEST_ADMIN_DATA" });

  // Delay the initial user check until data is retrieved
  checkAdminDataWithDelay().then((adminData) => {
    if (adminData) {
      localStorage.setItem("admin", JSON.stringify(adminData));
      // Optionally, update your Redux state here if needed
    }
  });
}
// Action creators are generated for each case reducer function
export const { getAdminData, adminLogout, updateAdminData } =
  adminSlice.actions;

export default adminSlice.reducer;
